// import * as focusTrap from 'focus-trap';
class mEditableField extends HTMLDivElement {
    constructor() {
        super();
        this.form = this.closest('form');
        this.editButton = this.querySelector('.cta-update');
        this.cancelButton = this.querySelector('.cta-cancel');
        this.contentValue = this.querySelector('.c-value');
        this.contentInput = this.querySelector('.c-input');
        this.hideInput = this.hideInput.bind(this);
        this.displayInput = this.displayInput.bind(this);
    }

    connectedCallback() {
        if (this.editButton) this.editButton.addEventListener('click', this.displayInput);
        if (this.cancelButton) this.cancelButton.addEventListener('click', this.hideInput);
    }

    hideInput() {
        this.form.setAttribute('data-overlay', false);
        this.setAttribute('data-field-show', false);
        this.contentValue.removeAttribute('hidden');
        this.contentValue.setAttribute('aria-hidden', false);
        this.contentInput.setAttribute('aria-hidden', true);
        this.editButton.setAttribute('aria-hidden', false);
        this.cancelButton.setAttribute('aria-hidden', true);
    }

    displayInput() {
        this.form.setAttribute('data-overlay', true);
        this.setAttribute('data-field-show', true);
        this.contentValue.setAttribute('hidden', true);
        this.contentValue.setAttribute('aria-hidden', true);
        this.contentInput.setAttribute('aria-hidden', false);
        this.editButton.setAttribute('aria-hidden', true);
        this.cancelButton.setAttribute('aria-hidden', false);
    }
}

customElements.define('m-editable-field', mEditableField, {
    extends: 'div'
});
